/*
 * @Author: cc
 * @Date: 2021-03-14 10:50:44
 * @LastEditTime: 2022-02-10 15:09:24
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\components\util\trsMediaSelector\avUploadService.js
 * @Description: 媒资选择框（阳光云视部分）
 */
angular.module('mediaSelectorSeviceModule', []).factory('mediaSelectorSevice', [
    // '$compile',
    // '$element',
    '$q',
    'editCenUploadVideoForXjService',
    'publicToolService',
    'modalDialog',
    'mrApiService',
    function ($q, editCenUploadVideoForXjService, publicToolService, modalDialog, mrApiService) {
        let scope;
        let uploadeMode;

        /**
        * [onSuccess description]
        * @param   {[type]}  res    [res description]
        * @return  {[type]}         [return description]
        */
        function onSuccess(res) {
            for (let i = 0; i < scope.unuploadList.length; i++) {
                if (scope.unuploadList[i].uniqueValue === res.uniqueValue) {
                    scope.unuploadList[i].relationId = JSON.parse(res.successRes.data).datas.relationid;
                    scope.startInterval(scope.unuploadList[i], i);
                    break;
                }
            }
            if (scope.status.uploadNum) {
                scope.status.uploadNum--;
            }
        }

        /**
        * [onMD5Progress description]
        * @param   {[type]}  res    [res description]
        * @return  {[type]}         [return description]
        */
        function onMD5Progress(res) {
            // console.log(res);
        }

        /**
        * [onUploadProgress description]
        * @param   {[type]}  fileInfo  [fileInfo description]
        * @return  {[type]}            [return description]
        */
        function onUploadProgress(fileInfo) {
            if (angular.isObject(fileInfo)) {
                for (let i = 0; i < scope.unuploadList.length; i++) {
                    if (scope.unuploadList[i].uniqueValue === fileInfo.uniqueValue) {
                        scope.unuploadList[i].progress = fileInfo.percentage.toFixed(2) + '%';
                        scope.$apply();
                        if (fileInfo.status === '正在计算文件内容，请等待') {
                            scope.unuploadList[i].status = '正在上传中...';
                            scope.status.canSaveMaterial = false;
                        }
                        if (fileInfo.progress === scope.status.complete) {
                            scope.unuploadList[i].status = '正在校验中...';
                            scope.status.canSaveMaterial = false;
                        }
                        break;
                    }
                }
            }
        }

        /**
        * [onStartUpload description] 文件上传前
        * @param   {[type]}  file   [file description]
        * @return  {[type]}         [return description]
        */
        function onStartUpload(file) {
            // console.log(file);
        }

        /**
        * [onFileinQueue description] 文件加入队列
        * @param   {[type]}  file   [file description]
        * @return  {[type]}         [return description]
        */
        function onFileinQueue(file) {
            let fileName = angular.copy(file.name);
            scope.status.uploadNum++;
            file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
            scope.unuploadList.push(file);
            scope.$apply();
            scope.unuploadList[scope.unuploadList.length - 1].status = '正在计算文件内容，请等待';
            scope.status.canSaveMaterial = false;
            scope.unuploadList[scope.unuploadList.length - 1].progress = '0%';
        }

        /**
        * [onError description] 上传失败
        * @param   {[type]}  res   [file description]
        * @return  {[type]}         [return description]
        */
        function onError(res) {
            modalDialog.alertType('上传失败', res.content, 'error', false);
        }

        /**
        * [initVideoUploader description]
        * @param   {[type]}  scopeInstance  [scope description]
        * @return  {[type]}         [return description]
        */
        function initVideoUploader(scopeInstance) {
            let defer = $q.defer();
            publicToolService.getModeconfiguration('avUploader').then((config) => {
                uploadeMode = config.mode;
                scope = scopeInstance;
                let uploaders = {
                    sunshine: {
                        example: '',
                        canNotPlay: false, // video标签只能播放MP4、WebM、Ogg的格式
                        progress: 0,
                        fastVideoTimer: '',
                        fastVideoInfo: {}, // 视频快编信息
                        speed: '0KB/S', // 上传速率
                        surplusTime: '', // 剩余时间
                        uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
                    },
                    general: {
                        onSuccess: onSuccess,
                        onMD5Progress: onMD5Progress,
                        onUploadProgress: onUploadProgress,
                        onStartUpload: onStartUpload,
                        onError: onError,
                        onFileinQueue: onFileinQueue,
                        fastVideoInfo: {
                            status: '',
                        }
    
                    }
                };
                let instance = uploaders[uploadeMode];
                if (uploadeMode === 'sunshine') {
                    instance.uploaderOptions.multiple = true;
                    if (scope.basicalStatus.commonParams.mainResourceType === '1') {
                        instance.uploaderOptions.accept = {
                            title: '音频',
                            extensions: 'mp3,flac,wav,wma',
                            mimeTypes: 'audio/*',
                        };
                        instance.registerUrl = '/bigdata/mr/personal/1/uploadByTempPath?';
                    }
                } else {
                    if (scope.basicalStatus.commonParams.mainResourceType === '1') {
                        angular.extend(instance, {
                            extensions: 'mp3,flac,wav,wma',
                            mimeType: 'audio/mpeg,audio/x-flac,audio/x-wav,audio/x-ms-wma'
                        });
                        instance.registerUrl = '/bigdata/mr/personal/1/uploadByTempPath?';
                    }
                }
                defer.resolve(instance);
            });
            return defer.promise;
        }

        /**
         * [uploadAsync description]
         * @param   {[type]}  file  [file description]
         * @return  {[type]}        [return description]
         */
        function uploadAsync(file) {
            scope.basicalStatus.commonParams.mrType = 'personal';
            mrApiService
                .uploadByUrl(
                    angular.extend(
                        {
                            fileName: file.fileName,
                            tempUrl: file.path,
                            mrEnable: 0
                        },
                        scope.basicalStatus.commonParams
                    )
                )
                .then(
                    (response) => {
                        if (response.code === '200') {
                            for (let i = 0; i < scope.unuploadList.length; i++) {
                                if (scope.unuploadList[i].id === file.id) {
                                    scope.unuploadList[i].relationId = scope.unuploadList[i].relationid = response.datas.relationid;
                                    scope.status.canSaveMaterial = true;
                                    scope.setUploadItemCache(i, scope.unuploadList[i]);
                                    scope.startInterval(scope.unuploadList[i], i);
                                    break;
                                }
                            }
                            if (scope.status.uploadNum) {scope.status.uploadNum--;}
                        } else {
                            scope.deleteList(file);
                            modalDialog.alertType(response.code, response.msg, 'error', false);
                        }
                    },
                    () => {
                        scope.deleteList(file);
                        modalDialog.alertType('校验失败', '请重新上传', 'error', false);
                    }
                );
        }

        /**
         * [doUploader description] 执行上传
         * @return  {[type]}  [return description]
         */
        function doUploader() {
            let upload = {
                sunshine: sunshineUpload,
                general: generalUpLoad
            };
            upload[uploadeMode]();
        }

        /**
         * [sunineUpload description] 云视上传
         * @return  {[type]}  [return description]
         */
        function sunshineUpload() {
            var upload = scope.uploader.example();
            scope.uploadObj = upload;
            scope.uploader.canNotPlay = false;
            upload.on('success', function (file) {
                uploadAsync(file);
                if (file.type !== 'video/mp4') {
                    scope.uploader.canNotPlay = true;
                }
            });
            upload.on('progress', function (obj) {
                for (let i = 0; i < scope.unuploadList.length; i++) {
                    if (scope.unuploadList[i].id === obj.id) {
                        scope.unuploadList[i].progress = obj.progress.toFixed(2) + '%';
                        scope.unuploadList[i].speed = obj.speed;
                        if (obj.file.status === '等待上传中') {
                            scope.unuploadList[i].status = '正在上传中...';
                            scope.status.canSaveMaterial = false;
                        }
                        if (obj.progress === scope.status.complete) {
                            scope.unuploadList[i].status = '正在校验中...';
                            scope.status.canSaveMaterial = false;
                        }
                        break;
                    }
                }
            });
            upload.on('fail', function (info) {
                scope.uploader.progress = 0;
                scope.deleteList(info);
            });
            // 上传文件的时候传过来进行分片计算是否展示需要进行文件校验等待
            upload.on('queued', function (file) {
                let fileName = angular.copy(file.file.name);
                scope.status.uploadNum++;
                file.file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                scope.unuploadList.push(file.file);
                scope.unuploadList[scope.unuploadList.length - 1].status = '等待上传中';
                scope.status.canSaveMaterial = false;
                scope.unuploadList[scope.unuploadList.length - 1].progress = '0%';
            });
        }

        /**
        * [generalUpLoad description] 通用上传
        * @return  {[type]}  [return description]
        */
        function generalUpLoad() {
            scope.uploader.selectFile();
        }
        return {
            initVideoUploader: initVideoUploader,
            doUploader: doUploader,
        };

    },
]);
